import { Tooltip } from "@mui/material";
import styled from "styled-components";

export const ServicesListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 16px;
  background-color: #ffffff;
  border-radius: 4px;
  padding: 24px;
`;

export const ServicesRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const servicesTooltipSx = {
  backgroundColor: "#202224",
  color: "#F2F4F7",
  borderRadius: "4px",
  padding: "4px 8px",
  fontFamily: '"Gotham", sans-serif',
  fontWeight: 325,
  fontSize: 12,
  lineHeight: 1.333,
  maxWidth: 267,
};

export const ServicesTooltip = styled(Tooltip)`
  margin-left: 8px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.primary.main};
`;
